import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { TbEyeClosed } from "react-icons/tb";
import { VscEye } from "react-icons/vsc";
import { getItemToken } from "../../../Utils/localStorageUtils";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { toast } from "react-toastify";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import { currentIpAddressDetails } from "../../../components/CommonMethod/CommonMethods";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import {
  CitySelect,
  CountrySelect,
  StateSelect,
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import { IoMdInformationCircle } from "react-icons/io";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function AddPartner() {
  const { fetchRequest, globalImageUplaodAPI } = useMyContext()
  const navigate = useNavigate();
  const [countryid, setCountryid] = useState(0);
  const [stateid, setstateid] = useState(0);
  const [cityid, setCityid] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleWorld = (name, value) => {
    setAddPartner({ ...addPartner, [name]: value });
  };

  // Refs for form fields
  const usernameRef = useRef(null);
  const lastnameRef = useRef(null);
  const emailRef = useRef(null);
  const profileRef = useRef(null);
  const mobileRef = useRef(null);
  const codeRef = useRef(null);
  const roleRef = useRef(null);
  const commissionRef = useRef(null);
  const passwordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const bankNameRef = useRef(null);
  const branchNameRef = useRef(null);
  const accountNumberRef = useRef(null);
  const ifscCodeRef = useRef(null);
  const upiIdRef = useRef(null);
  const upiMobileRef = useRef(null);

  const userAccessToken = getItemToken("access_token");
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [profileImageFile, setProfileImageFile] = useState("");
  const [thumbnailImageFile, setThumbnailImageFile] = useState("");
  const [addPartnerError, setAddPartnerError] = useState({});
  const [showOverlay, setShowOverlay] = useState(false);
  const [domReload, setDomReload] = useState(false);
  const [defaultData, setDefaultData] = useState([]);
  const [customFieldValues, setCustomFieldValues] = useState({});
  const [addPartner, setAddPartner] = useState({
    username: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
    mobile_number: "",
    avatar: "",
    ccode: "",
    ccode_unique: "",
    city: "",
    state: "",
    country: "",
    gender: "",
    commission_percentage: "",
    bank_name: "",
    branch_name: "",
    account_number: "",
    IFSC_Code: "",
    upi_id: "",
    upi_mobile_number: "",
    role_id: "",
    status: 1,
  });

  const access_token = localStorage.getItem("access_token");
  const headers = {
    Authorization: "Bearer " + access_token,
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const handleInput = (e) => {
    const { name, type, value, checked } = e.target;

    if (type === "checkbox") {
      setAddPartner((prevAddPartner) => ({
        ...prevAddPartner,
        [name]: checked ? 1 : 0,
      }));
    }
    if (type === "text" || type == "number" || type == "email" || type == "password") {
      if ((name === "username" || name === "last_name") && /\d/.test(value)) {
        return;
      }
      setAddPartner((prevAddPartner) => ({
        ...prevAddPartner,
        [name]: value || "",
      }));
    }
    if (type === "select-one") {
      setAddPartner((prev) => ({
        ...prev,
        [name]: value,
      }));
      setAddPartnerError((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    setAddPartnerError((prevAddPartnerError) => ({
      ...prevAddPartnerError,
      [name]: "",
    }));
  };

  // Fetch partner creation data
  const fetchData = async () => {
    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/partner/create`, {
        headers: userAccessToken,
      })
      .then((response) => {
        setDefaultData((prev) => ({
          ...prev,
          partnerRoles: response?.data?.partnerRoles,
          country: response?.data?.country,
          partnersignupmenu: response?.data?.partnersignupmenu,
        }));
      })
      .catch((error) => toast.error(error?.response?.data?.message));
  };

  // Handle image upload
  const handleImageChange = async (event) => {
    const { files, name } = event.target;
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
    setAddPartnerError((prev) => ({
      ...prev,
      [name]: "",
    }));
    if (!files?.[0]) return;
    const selected = files[0];
    if (!allowedTypes.includes(selected.type)) {
      setAddPartnerError((prev) => ({
        ...prev,
        [name]: "Only JPG, JPEG, and PNG files are allowed.",
      }));
      if (name === "image") setProfileImageFile(null);
      if (name === "thumbnail") setThumbnailImageFile(null);
      return;
    }
    if (files?.length > 0) {
      const newFile = files[0];
      if (name === "image") setProfileImageFile(newFile);
      if (name === "thumbnail") setThumbnailImageFile(newFile);
    }
  };

  // Form validation
  const formValidation = () => {
    let formIsValid = true;
    const nameRegex = /^[A-Za-z\s]+$/;

    if (!addPartner?.username) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        username: "User Name cannot be empty.",
      }));
      usernameRef.current.focus();
      formIsValid = false;
    } else if (/\d/.test(addPartner?.username)) {
      setAddPartnerError((prev) => ({
        ...prev,
        username: "User Name should not contain numbers.",
      }));
      usernameRef.current.focus();
      formIsValid = false;
    } else if (!nameRegex.test(addPartner?.username)) {
      setAddPartnerError((prev) => ({
        ...prev,
        username: "User Name should not contain special characters.",
      }));
      usernameRef.current.focus();
      formIsValid = false;
    }

    if (!addPartner?.last_name) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        last_name: "Last Name cannot be empty.",
      }));
      lastnameRef.current.focus();
      formIsValid = false;
    } else if (/\d/.test(addPartner?.last_name)) {
      setAddPartnerError((prev) => ({
        ...prev,
        last_name: "Last Name should not contain numbers.",
      }));
      lastnameRef.current.focus();
      formIsValid = false;
    } else if (!nameRegex.test(addPartner?.last_name)) {
      setAddPartnerError((prev) => ({
        ...prev,
        last_name: "Last Name should not contain special characters.",
      }));
      lastnameRef.current.focus();
      formIsValid = false;
    }

    const normalizedEmail = addPartner.email?.toLowerCase().trim();
    if (!normalizedEmail) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        email: "Email cannot be empty",
      }));
      emailRef.current.focus();
      formIsValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(normalizedEmail)
    ) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        email: "Invalid email address",
      }));
      emailRef.current.focus();
      formIsValid = false;
    } else {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        email: "",
      }));
      setAddPartner((prevPartner) => ({
        ...prevPartner,
        email: normalizedEmail,
      }));
    }

    if (!addPartner?.password) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        password: "Password cannot be empty.",
      }));
      passwordRef.current.focus();
      formIsValid = false;
    } else if (addPartner?.password?.length < 8) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        password: "Password must be at least 8 characters long.",
      }));
      passwordRef.current.focus();
      formIsValid = false;
    }

    if (!addPartner?.confirm_password) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        confirm_password: "Confirm Password cannot be empty.",
      }));
      confirmPasswordRef.current.focus();
      formIsValid = false;
    } else if (addPartner?.password !== addPartner?.confirm_password) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        confirm_password: "Passwords do not match.",
      }));
      confirmPasswordRef.current.focus();
      formIsValid = false;
    }

    if (!addPartner?.ccode) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        ccode: "Code cannot be empty.",
      }));
      codeRef.current.focus();
      formIsValid = false;
    }

    if (!addPartner?.mobile_number) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        mobile_number: "Mobile Number cannot be empty.",
      }));
      mobileRef.current.focus();
      formIsValid = false;
    } else if (addPartner?.mobile_number?.length < 7) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        mobile_number: "Mobile Number atleast contain 7 digits.",
      }));
      mobileRef.current.focus();
      formIsValid = false;
    } else if (addPartner?.mobile_number?.length > 15) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        mobile_number: "Mobile number cannot be more than 15 digits.",
      }));
      mobileRef.current.focus();
      formIsValid = false;
    }

    if (!addPartner?.commission_percentage) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        commission_percentage: "Commission percentage cannot be empty.",
      }));
      commissionRef.current.focus();
      formIsValid = false;
    } else if (
      addPartner?.commission_percentage < 0 ||
      addPartner?.commission_percentage > 100
    ) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        commission_percentage: "Commission percentage must be between 0 and 100.",
      }));
      commissionRef.current.focus();
      formIsValid = false;
    }


    if (!addPartner?.role_id) {
      setAddPartnerError((prevFormData) => ({
        ...prevFormData,
        role_id: "Role cannot be empty.",
      }));
      roleRef.current.focus();
      formIsValid = false;
    }

    // ========== BANK DETAILS VALIDATION (REMOVED) ==========

    // ========== OPTIONAL FIELDS VALIDATION (Only if filled) ==========

    // IFSC Code validation - only if user enters something
    if (addPartner?.IFSC_Code?.trim()) {
      const ifscRegex = /^[A-Z]{4}[0][A-Z0-9]{6}$/; // Format: HDFC0001234
      if (!ifscRegex.test(addPartner?.IFSC_Code?.trim().toUpperCase())) {
        setAddPartnerError((prevFormData) => ({
          ...prevFormData,
          IFSC_Code: "Invalid IFSC Code format. Example: HDFC0001234",
        }));
        ifscCodeRef.current.focus();
        formIsValid = false;
      }
    }

    // UPI ID validation - only if user enters something
    if (addPartner?.upi_id?.trim()) {
      const upiRegex = /^[a-zA-Z0-9.\-_]+@[a-zA-Z0-9]+$/; // Format: test@bankhdfc
      if (!upiRegex.test(addPartner?.upi_id?.trim())) {
        setAddPartnerError((prevFormData) => ({
          ...prevFormData,
          upi_id: "Invalid UPI ID format. Example: test@bankhdfc",
        }));
        upiIdRef.current.focus();
        formIsValid = false;
      }
    }

    // UPI Mobile Number validation - only if user enters something
    if (addPartner?.upi_mobile_number?.toString().trim()) {
      const upiMobile = addPartner?.upi_mobile_number?.toString().trim();
      if (!/^[0-9]+$/.test(upiMobile)) {
        setAddPartnerError((prevFormData) => ({
          ...prevFormData,
          upi_mobile_number: "UPI Mobile Number must contain only digits.",
        }));
        upiMobileRef.current.focus();
        formIsValid = false;
      } else if (upiMobile.length > 15) {
        setAddPartnerError((prevFormData) => ({
          ...prevFormData,
          upi_mobile_number: "UPI Mobile Number cannot be more than 15 digits.",
        }));
        upiMobileRef.current.focus();
        formIsValid = false;
      } else if (upiMobile.length < 7) {
        setAddPartnerError((prevFormData) => ({
          ...prevFormData,
          upi_mobile_number: "UPI Mobile Number must be at least 7 digits.",
        }));
        upiMobileRef.current.focus();
        formIsValid = false;
      }
    }

    return formIsValid;
  };

  // Handle image upload for partner via centralized global image upload API
  const handleImageUpload = async (userId, partnerId) => {
    if (profileImageFile && userId) {
      try {
        const fd = new FormData();
        fd.append('id', String(userId));
        fd.append('modelName', 'User');
        fd.append('avatar', profileImageFile);
        fd.append('imageFields[]', 'avatar');

        await fetchRequest({ method: 'POST', url: globalImageUplaodAPI(), data: fd });
      } catch (err) {
        console.error('Profile image upload failed', err);
      }
    }

    if (thumbnailImageFile && partnerId) {
      try {
        const fd = new FormData();
        fd.append('id', String(partnerId));
        fd.append('modelName', 'Partner');
        fd.append('thumbnail_image', thumbnailImageFile);
        fd.append('imageFields[]', 'thumbnail_image');

        await fetchRequest({ method: 'POST', url: globalImageUplaodAPI(), data: fd });
      } catch (err) {
        console.error('Thumbnail image upload failed', err);
      }
    }
  };

  // Handle create
  const handleCreate = async () => {
    setShowOverlay(true);
    try {
      const formData = {
        username: addPartner?.username,
        last_name: addPartner?.last_name,
        email: addPartner?.email,
        password: addPartner?.password,
        ccode: `${addPartner?.ccode}`,
        mobile_number: addPartner?.mobile_number,
        city: addPartner?.city,
        state: addPartner?.state,
        country: addPartner?.country,
        gender: addPartner?.gender,
        commission_percentage: addPartner?.commission_percentage,
        bank_name: addPartner?.bank_name,
        branch_name: addPartner?.branch_name,
        account_number: addPartner?.account_number,
        IFSC_Code: addPartner?.IFSC_Code,
        upi_id: addPartner?.upi_id,
        upi_mobile_number: addPartner?.upi_mobile_number,
        role_id: addPartner?.role_id,
        status: addPartner?.status,
      };

      await axios
        .post(
          `${process.env.REACT_APP_Baseurl}/admin/partner/store`,
          formData,
          {
            headers: userAccessToken,
          }
        )
        .then(async (res) => {
          if (res?.data?.status) {
            const partnerId = res?.data?.PartnerUserID || res?.data?.id || res?.data?.data?.id || res?.data?.partner_id;
            const userId = res?.data?.userData?.id;
            // save custom field values (strict)
            try {
              if (partnerId) {
                const { saveCustomFieldsConditional } = await import('../../../CustomFields/conditionalCustomFieldsWrapper');
                const cfRes = await saveCustomFieldsConditional(
                  process.env.REACT_APP_Baseurl,
                  userAccessToken,
                  'partner',
                  partnerId,
                  customFieldValues
                );
                if (!cfRes?.data?.status) throw new Error(cfRes?.data?.message || 'Failed to save additional fields');
              }
            } catch (e) {
              toast.error(e?.response?.data?.message || e.message || 'Failed to save additional fields');
              setShowOverlay(false);
              return;
            }
            if (userId && (profileImageFile || thumbnailImageFile)) {
              await handleImageUpload(userId, partnerId);
            }
            toast.success(res?.data?.message);
            setDomReload(!domReload);
            setProfileImageFile(null);
            setThumbnailImageFile(null);
            setAddPartnerError({});
            setShowOverlay(false);
            navigate("/all-partner");
          } else {
            toast.error(res?.data?.message);
            setShowOverlay(false);
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || "Something went wrong!");
          setShowOverlay(false);
        });
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong!");
      setShowOverlay(false);
    }
  };

  const handleValidate = async (e) => {
    e.preventDefault();
    if (formValidation()) {
      handleCreate();
    } else {
      console.log("Form validation failed");
    }
  };

  const handleClearSelectFile = (value) => {
    if (value === 'image') setProfileImageFile(null);
    if (value === 'thumbnail') setThumbnailImageFile(null);
    setAddPartnerError((prev) => ({
      ...prev,
      [value]: "",
    }));
  };

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  useEffect(async () => {
    await fetchData();
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Label-Management/list-source`,
        {
          headers: headers,
          params: { source: "add-partner" },
        }
      );
      setLabelDisplay(response?.data?.label_management || []);
    } catch (error) {
      console.error("Error fetching label display:", error);
    }
  }, [domReload]);

  useEffect(() => {
    const fetchCCode = async () => {
      if (!addPartner?.ccode && defaultData?.country) {
        try {
          const res = await currentIpAddressDetails();
          if (res) {
            const matchingCounties = defaultData?.country?.filter(
              (item) => item?.sortname === res?.country_code
            )[0]?.phonecode;

            setAddPartner((prev) => ({
              ...prev,
              ccode: `+${matchingCounties}`,
              ccode_unique: `${res?.country_code},+${matchingCounties}`,
            }));
          } else {
            toast.error('Failed to retrieve IP address details.');
          }
        } catch (error) {
          console.error("Error in fetchCCode:", error);
        }
      }
    };
    fetchCCode();
  }, [addPartner?.ccode, defaultData?.country]);

  useEffect(() => {
    if (addPartner?.ccode && defaultData?.country && !addPartner?.ccode_unique) {
      let match = defaultData.country.find(c => c.id == addPartner.country || c.id == countryid);
      if (!match || `+${match.phonecode}` !== addPartner.ccode) {
         match = defaultData.country.find(c => `+${c.phonecode}` === addPartner.ccode);
      }
      if (match) {
         const phoneCode = `+${match.phonecode}`;
         setAddPartner(prev => ({ ...prev, ccode_unique: `${match.sortname},${phoneCode}` }));
      }
    }
  }, [addPartner?.ccode, defaultData?.country, countryid, addPartner?.country, addPartner?.ccode_unique]);

  const getSelectedPhoneCountry = () => {
    if (addPartner?.ccode_unique?.includes(",")) {
      return addPartner.ccode_unique.split(",")[0]?.toLowerCase();
    }

    if (addPartner?.country && defaultData?.country?.length) {
      const matchedCountry = defaultData.country.find(
        (item) => item?.country_name?.toLowerCase() === addPartner.country?.toLowerCase()
      );
      if (matchedCountry?.sortname) return matchedCountry.sortname.toLowerCase();
    }

    return "in";
  };

  return (
    <>
      {showOverlay && <Response_Processing></Response_Processing>}
      {<AdminBackNavigation path={`${"/all-partner"}`} text="Back" />}
      <AdminSaveHeader
        heading="Add Partner"
        saveText="Create"
        saveMethod={handleValidate}
        type="submit"
      />
      <form onSubmit={handleValidate}>
        <FormContainer>
          <LeftWrapper>
            <Wrapper>
              <MessageHeading text="Partner Information" />

              <MessageLabel text="Username" className="mandatorySimple" />
              <AdminCustomInput
                type="text"
                id="username"
                name="username"
                value={addPartner?.username}
                placeHolder={"Enter username"}
                ref={usernameRef}
                onChange={handleInput}
                error={addPartnerError?.username}
              />

              <MessageLabel text="Last Name" className="mandatorySimple" />
              <AdminCustomInput
                type="text"
                id="last_name"
                name="last_name"
                value={addPartner?.last_name}
                placeHolder={"Enter last name"}
                ref={lastnameRef}
                onChange={handleInput}
                error={addPartnerError?.last_name}
              />

              <MessageLabel text="Email" className="mandatorySimple" />
              <AdminCustomInput
                type="email"
                id="email"
                name="email"
                value={addPartner?.email}
                placeHolder={"Enter email address"}
                ref={emailRef}
                onChange={handleInput}
                error={addPartnerError?.email}
              />

              <MessageLabel text="Password" className="mandatorySimple" />
              <div className="position-relative">
                <AdminCustomInput
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={addPartner?.password}
                  placeHolder={"Enter password"}
                  ref={passwordRef}
                  onChange={handleInput}
                  error={addPartnerError?.password}
                />
                <div
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    zIndex: 10,
                  }}
                  onClick={togglePassword}
                >
                  {showPassword ? (
                    <VscEye className="theme-text-color" />
                  ) : (
                    <TbEyeClosed className="theme-text-color" />
                  )}
                </div>
              </div>

              <MessageLabel text="Confirm Password" className="mandatorySimple" />
              <div className="position-relative">
                <AdminCustomInput
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirm_password"
                  name="confirm_password"
                  value={addPartner?.confirm_password}
                  placeHolder={"Confirm password"}
                  ref={confirmPasswordRef}
                  onChange={handleInput}
                  error={addPartnerError?.confirm_password}
                />
                <div
                  className="position-absolute"
                  style={{
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    zIndex: 10,
                  }}
                  onClick={toggleConfirmPassword}
                >
                  {showConfirmPassword ? (
                    <VscEye className="theme-text-color" />
                  ) : (
                    <TbEyeClosed className="theme-text-color" />
                  )}
                </div>
              </div>

              <MessageLabel text="Mobile Number" className="mandatorySimple" />
              <div className="mb-3 admin-phone-input-wrapper">
                <PhoneInput
                  country={getSelectedPhoneCountry()}
                  value={`${String(addPartner?.ccode || "").replace("+", "")}${addPartner?.mobile_number || ""}`}
                  onChange={(value, countryData) => {
                    const dialCode = countryData?.dialCode ? `+${countryData.dialCode}` : "";
                    const mobileNumber = dialCode ? value.slice(countryData.dialCode.length) : value;
                    const countryCode = countryData?.countryCode?.toUpperCase() || "";

                    setAddPartner((prev) => ({
                      ...prev,
                      ccode: dialCode,
                      ccode_unique: countryCode ? `${countryCode},${dialCode}` : prev?.ccode_unique,
                      mobile_number: mobileNumber || "",
                    }));

                    setAddPartnerError((prev) => ({
                      ...prev,
                      ccode: "",
                      mobile_number: "",
                    }));
                  }}
                  inputProps={{
                    id: "mobile_number",
                    name: "mobile_number",
                    ref: (input) => {
                      mobileRef.current = input;
                      codeRef.current = input;
                    },
                  }}
                  placeholder="Enter mobile number"
                  countryCodeEditable={false}
                  disableSearchIcon
                  enableSearch
                  inputStyle={{ width: "100%" }}
                  inputClass="bg-transparent theme-text-color rounded-0 ownInputFlag admin-phone-input"
                  dropdownClass="theme-bg-color theme-text-color ownInputDropDown"
                  buttonClass="bg-transparent border-0 p-1 ownButtonClass admin-phone-button"
                />
                {addPartnerError?.mobile_number && (
                  <div className='d-flex align-items-center gap-1 mt-2'>
                    <IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} />
                    <MessageBox text={addPartnerError?.mobile_number} classname='errorred d-block' />
                  </div>
                )}
                {addPartnerError?.ccode && !addPartnerError?.mobile_number && (
                  <div className='d-flex align-items-center gap-1 mt-2'>
                    <IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} />
                    <MessageBox text={addPartnerError?.ccode} classname='errorred d-block' />
                  </div>
                )}
              </div>

              <MessageLabel text="Gender" />
              <AdminCustomSelect
                name="gender"
                value={addPartner?.gender}
                onChange={handleInput}
                options={[
                  { value: "male", name: "Male" },
                  { value: "female", name: "Female" },
                  { value: "other", name: "Other" }
                ]}
                defaultOptionName="Select Gender"
                error={addPartnerError?.gender}
              />

              <MessageLabel text="Commission Percentage" className="mandatorySimple" />
              <AdminCustomInput
                type="number"
                id="commission_percentage"
                name="commission_percentage"
                min={0}
                max={100}
                value={addPartner?.commission_percentage}
                placeHolder={"Enter commission percentage"}
                ref={commissionRef}
                onChange={handleInput}
                error={addPartnerError?.commission_percentage}
              />
            </Wrapper>

            {/* <Wrapper>
              <div className="card p-3 mt-3">
                <MessageHeading text="Additional Fields" />
               
                <FieldRenderer2
                  pageIdentifier={"site_partner.create"}
                  entityType={"partner"}
                  entityId={null}
                  text="Additional Fields"
                />
                <FieldRenderer
                  pageIdentifier={"site_partner.create"}
                  entityType={"partner"}
                  entityId={null}
                  onChange={setCustomFieldValues}
                />
              </div>
            </Wrapper> */}

            <Wrapper>
              <MessageHeading text="Bank Details" />

              <MessageLabel text="Bank Name" className="" />
              <AdminCustomInput
                type="text"
                id="bank_name"
                name="bank_name"
                value={addPartner?.bank_name}
                placeHolder={"Enter bank name"}
                ref={bankNameRef}
                onChange={handleInput}
                error={addPartnerError?.bank_name}
              />

              <MessageLabel text="Branch Name" className="" />
              <AdminCustomInput
                type="text"
                id="branch_name"
                name="branch_name"
                value={addPartner?.branch_name}
                placeHolder={"Enter branch name"}
                ref={branchNameRef}
                onChange={handleInput}
                error={addPartnerError?.branch_name}
              />

              <MessageLabel text="Account Number" className="" />
              <AdminCustomInput
                type="text"
                id="account_number"
                name="account_number"
                value={addPartner?.account_number}
                placeHolder={"Enter account number"}
                ref={accountNumberRef}
                onChange={handleInput}
                error={addPartnerError?.account_number}
              />

              <MessageLabel text="IFSC Code" />
              <AdminCustomInput
                type="text"
                id="IFSC_Code"
                name="IFSC_Code"
                value={addPartner?.IFSC_Code}
                placeHolder={"Enter IFSC code"}
                ref={ifscCodeRef}
                onChange={handleInput}
                error={addPartnerError?.IFSC_Code}
              />

              <MessageLabel text="UPI ID" />
              <AdminCustomInput
                type="text"
                id="upi_id"
                name="upi_id"
                value={addPartner?.upi_id}
                placeHolder={"Enter UPI ID (e.g., test@bankhdfc)"}
                ref={upiIdRef}
                onChange={handleInput}
                error={addPartnerError?.upi_id}
              />

              <MessageLabel text="UPI Mobile Number" />
              <AdminCustomInput
                type="number"
                id="upi_mobile_number"
                name="upi_mobile_number"
                value={addPartner?.upi_mobile_number}
                placeHolder={"Enter UPI mobile number (max 15 digits)"}
                ref={upiMobileRef}
                onChange={handleInput}
                error={addPartnerError?.upi_mobile_number}
              />
            </Wrapper>

            <Wrapper>
              <MessageHeading text="Status" />
              <div className="row mx-0">
                <div className="col-9 ps-0">
                  <MessageLabel text="Active Status" />
                </div>
                <div className="col-3 text-end">
                  <label className="switch">
                    <input
                      name="status"
                      onChange={handleInput}
                      checked={Number(addPartner?.status) === 1}
                      type="checkbox"
                      className="rs-input"
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </Wrapper>
          </LeftWrapper>

          <RightWrapper>
            <Wrapper>
              <MessageHeading text="Profile Image" />
              <AdminImageUploadZone
                onChange={handleImageChange}
                selectedFile={profileImageFile}
                uploadedImage={addPartner?.avatar}
                onDelete={() => handleClearSelectFile('image')}
                ref={profileRef}
                name="image"
                accept="image/jpeg,image/png,image/jpg,image/webp"
                error={addPartnerError?.image}
              />
            </Wrapper>

            <Wrapper>
              <MessageHeading text="Thumbnail Image" />
              <AdminImageUploadZone
                onChange={handleImageChange}
                selectedFile={thumbnailImageFile}
                onDelete={() => handleClearSelectFile('thumbnail')}
                name="thumbnail"
                accept="image/jpeg,image/png,image/jpg,image/webp"
                error={addPartnerError?.thumbnail}
              />
            </Wrapper>

            <Wrapper>
              <MessageHeading text="Region" />
              <div className="d-flex position-relative ">
                <p className="mb-3 mt-2 admin-input-title d-block position-relative">
                  Country
                </p>
              </div>
              <CountrySelect
                id="country-select"
                onChange={(e) => {
                  setCountryid(e.id);
                  handleWorld("country", e.name);
                }}
                defaultValue={
                  addPartner?.country ? { name: addPartner.country } : null
                }
                placeHolder="Select Country"
                inputClassName="bg-transparent theme-border-color theme-text-color border-0 country-input"
                containerClassName="custom-country"
              />

              <div className="d-flex position-relative ">
                <p className="mb-3 mt-2 admin-input-title d-block position-relative">
                  State
                </p>
              </div>

              <StateSelect
                id="state-select"
                key={`${countryid}-${addPartner?.state || ""}`}
                countryid={countryid}
                onChange={(e) => {
                  setstateid(e.id);
                  handleWorld("state", e.name);
                }}
                defaultValue={
                  addPartner?.state ? { name: addPartner.state } : undefined
                }
                placeHolder="Select State"
                inputClassName="bg-transparent theme-text-color border-0 country-input"
                containerClassName="custom-country"
              />

              <div className="d-flex position-relative ">
                <p className="mb-3 mt-2 admin-input-title d-block position-relative">
                  City
                </p>
              </div>

              <CitySelect
                id="city-select"
                key={`${countryid}-${stateid}-${addPartner?.city || ""}`}
                countryid={countryid}
                stateid={stateid}
                onChange={(e) => {
                  setCityid(e.id);
                  handleWorld("city", e.name);
                }}
                defaultValue={
                  addPartner?.city ? { name: addPartner.city } : undefined
                }
                placeHolder="Select City"
                inputClassName="bg-transparent theme-text-color border-0 country-input"
                containerClassName="custom-country"
              />
            </Wrapper>

            <Wrapper>
              <MessageHeading text="Role" />
              <MessageLabel text="Partner Role" className="mandatorySimple" />
              <AdminCustomSelect
                name="role_id"
                value={addPartner?.role_id}
                onChange={handleInput}
                options={defaultData?.partnerRoles ? [
                  {
                    value: defaultData.partnerRoles.id,
                    name: defaultData.partnerRoles.role_name
                  }
                ] : []}
                defaultOptionName="Select Role"
                ref={roleRef}
                error={addPartnerError?.role_id}
              />
            </Wrapper>
          </RightWrapper>
        </FormContainer>
        <AdminCustomButton
          saveMethod={handleValidate}
          saveText="Create Partner"
          type="submit"
          className="d-block ms-auto"
        />
      </form>
    </>
  );
}
export default AddPartner;
